import { DashboardSdk } from '@bringg/frontend-utils';
import { CreateTaskInventory, Customer, Task } from '@bringg/types';

import { saveTask } from 'Services';
import { DeliveryOptions, ECommerceSettings } from 'Types';
import { buildDeliveryTask } from '../helpers';

export const createDeliveryInternalDriver = async (
  settings: ECommerceSettings,
  customer: Customer,
  inventories: CreateTaskInventory[],
  delivery: DeliveryOptions,
  dashboardSDK: DashboardSdk,
  onProgress?: (percent: number) => void
): Promise<Task> => {
  const merchant = await dashboardSDK.sdk.merchant.get();
  const task = buildDeliveryTask(settings, customer, inventories, delivery, merchant);
  onProgress && onProgress(0);

  const users = await dashboardSDK.sdk.users.getDriversByTeam(settings.team.id);
  const userId = users[0].id;
  task.user_id = userId;

  const persistedTask = await saveTask(task);
  onProgress && onProgress(100);
  return persistedTask;
};
